import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const InputContext = createContext();

export const InputProvider = ({ children }) => {
  const [inputValue, setInputValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [twoWheelerResults, setTwoWheelerResults] = useState([]);
  const [mobile , setMobile] = useState([]);
  const [accessiories , setAccessiories] = useState([]);
  const [laptopacce , setLaptopacce] = useState([]);
  const [error, setError] = useState(null); // Error state

  // Handle search input change
  const handleSearch = useCallback(async (term) => {
    console.log("Handling search for term:", term); // Debug log
    setInputValue(term);
    sessionStorage.setItem('name', term); // Store the term in session storage

    if (term) {
      setError(null); // Reset error before searching
      await searchEmployees(term);
      await searchTwoWheelers(term);
      await searchMobile(term);
      await searchAccessiories(term);
      await laptopAccessiories(term);
    } else {
      setSearchResults([]); // Clear results if term is empty
      setTwoWheelerResults([]); // Clear results if term is empty
      setMobile([]); // Clear results if term is empty
      setAccessiories([]);
      setLaptopacce([]);
    }
  }, [sessionStorage.getItem('name')]); 

  // Search employees
  const searchEmployees = async (term) => {
    console.log("Searching employees for term:", term); // Debug log
    try {
      const response = await axios.get(`https://api.assetview.warrantyindia.com/search?q=${term}`);
      console.log("Employee search results:", response.data); // Debug log
      setSearchResults(response.data);
    } catch (error) {
      console.error('Error fetching employee data:', error);
      setSearchResults([]); // Clear results on error
      setError('Failed to fetch employee data.'); // Set error message
    }
  };

  // Search two-wheelers
  const searchTwoWheelers = async (term) => {
    console.log("Searching two-wheelers for term:", term); // Debug log
    try {
      const response = await axios.get(`https://api.assetview.warrantyindia.com/api/search-twowheeler?q=${term}`);
      console.log("Two-wheeler search results:", response.data); // Debug log
      setTwoWheelerResults(response.data);
    } catch (error) {
      console.error('Error fetching two-wheeler data:', error);
      setTwoWheelerResults([]); // Clear results on error
      setError('Failed to fetch two-wheeler data.'); // Set error message
    }
  };

  // Search two-wheelers
  const searchMobile = async (term) => {
    console.log("Searching two-wheelers for term:", term); // Debug log
    try {
      const response = await axios.get(`https://api.assetview.warrantyindia.com/api/search-mobile?q=${term}`);
      console.log("Two-wheeler search results:", response.data); // Debug log
      setMobile(response.data);
    } catch (error) {
      console.error('Error fetching two-wheeler data:', error);
      setMobile([]); // Clear results on error
      setError('Failed to fetch two-wheeler data.'); // Set error message
    }
  };

  const searchAccessiories = async (term) => {
    console.log("Searching two-wheelers for term:", term); // Debug log
    try {
      const response = await axios.get(`https://api.assetview.warrantyindia.com/api/search-accessories?q=${term}`);
      console.log("Two-wheeler search results:", response.data); // Debug log
      setAccessiories(response.data);
    } catch (error) {
      console.error('Error fetching two-wheeler data:', error);
      setAccessiories([]); // Clear results on error
      setError('Failed to fetch two-wheeler data.'); // Set error message
    }
  };

  const laptopAccessiories = async (term) => {
    console.log("Searching two-wheelers for term:", term); // Debug log
    try {
      const response = await axios.get(`https://api.assetview.warrantyindia.com/api/search-accessories1?q=${term}`);
      console.log("Laptop Accessiories search results:", response.data); // Debug log
      setLaptopacce(response.data);
    } catch (error) {
      console.error('Error fetching two-wheeler data:', error);
      setLaptopacce([]); // Clear results on error
      setError('Failed to fetch two-wheeler data.'); // Set error message
    }
  };

  // Load input value from session storage on mount
  useEffect(() => {
    const storedInputValue = sessionStorage.getItem('name');
    if (storedInputValue) {
      setInputValue(storedInputValue);
      if (storedInputValue.trim()) {  // Check for valid input
        handleSearch(storedInputValue); // Trigger search with stored value
      }
    }
  }, [handleSearch]); // Add handleSearch to dependency array

  return (
    <InputContext.Provider value={{
      inputValue, 
      setInputValue, 
      mobile,
      accessiories,
      laptopacce,
      searchResults, 
      twoWheelerResults, 
      handleSearch,
      error, // Provide error state
    }}>
      {children}
    </InputContext.Provider>
  );
};

export const useInput = () => useContext(InputContext);
